import PeriodCommitmentController from "../../../controllers/period_commitment_controller"
import "./component.scss"

export default class extends PeriodCommitmentController {
  connect() {
    this.form = this.element.closest("form")
    this.periodChanged = () => this.update()
    this.form.addEventListener("change", this.periodChanged)
    this.form.addEventListener("price-phases:changed", this.periodChanged)
    super.connect()
  }

  disconnect() {
    this.form.removeEventListener("change", this.periodChanged)
    this.form.removeEventListener("price-phases:changed", this.periodChanged)
  }
}
